import { ArrowRight, Shield, Scale, ClipboardCheck, Instagram, Youtube, Facebook, Linkedin } from "lucide-react";

const POINTS = [
  {
    icon: Shield,
    title: "Account-Sperrungen",
    text: "Account-Sperrungen auf TikTok, Instagram und weiteren Plattformen – strukturiert aufbereitet.",
  },
  {
    icon: Scale,
    title: "Außergerichtliche Schlichtung",
    text: "Erreichung von zertifizierten außergerichtlichen Streitschlichtungsstellen nach DSA.",
  },
  {
    icon: ClipboardCheck,
    title: "Vollständige Begleitung",
    text: "Administrative Prozessbegleitung von Anfang bis Ende – diskret und nachvollziehbar.",
  },
];

// Inline TikTok / X / Threads icons (not in lucide-react)
const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.5a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.42Z" />
  </svg>
);
const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.244 2H21l-6.52 7.452L22 22h-6.81l-4.79-6.345L4.7 22H2l7.05-8.058L2 2h6.91l4.33 5.785L18.244 2Zm-2.38 18h1.876L8.21 4H6.24l9.624 16Z" />
  </svg>
);
const ThreadsIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.18 23h-.04C8.06 22.97 4.95 21.57 3.1 18.96 1.45 16.62.6 13.36.58 9.27V9.26c.02-4.1.87-7.35 2.52-9.69C5.04-2.55 8.18-3.97 12.21-4h.05c3.09.02 5.67.81 7.66 2.34 1.88 1.45 3.21 3.51 3.93 6.13l-2.13.59c-1.24-4.42-4.39-6.71-9.47-6.75-3.36.03-5.91 1.07-7.55 3.13-1.54 1.94-2.34 4.74-2.36 8.31.02 3.57.82 6.36 2.36 8.31 1.64 2.05 4.19 3.1 7.55 3.13 3.03-.02 5.04-.74 6.71-2.39 1.91-1.89 1.88-4.2 1.27-5.61-.36-.83-1.01-1.52-1.88-2.03-.22 1.55-.71 2.81-1.46 3.77-1 1.27-2.42 1.97-4.21 2.05-1.36.06-2.66-.26-3.68-.91-1.2-.77-1.91-1.95-1.99-3.34-.16-2.71 2-4.65 5.39-4.85.4-.02 1.06-.05 1.96.04-.12-.72-.36-1.29-.71-1.7-.49-.57-1.24-.86-2.24-.87h-.04c-.79 0-1.86.22-2.55 1.21l-1.83-1.23c.92-1.34 2.42-2.07 4.36-2.07h.06c3.27.02 5.21 2.04 5.41 5.56.11.05.22.09.33.14 1.55.73 2.68 1.83 3.27 3.21.83 1.91.91 5.04-1.62 7.55-1.93 1.91-4.27 2.78-7.59 2.8l.01.01ZM12.27 12c-.31 0-.62.01-.94.02-2.59.15-3.7 1.42-3.62 2.43.08 1.45 1.67 2.13 3.21 2.06 1.42-.07 3.03-.61 3.3-3.79-.55-.13-1.18-.21-1.86-.21l-.09-.51Z" />
  </svg>
);
const SnapchatIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.03 2c2.79 0 5.16 1.74 6.16 4.21.34.84.32 2.27.31 3.43v.18c0 .12 0 .26-.01.4.34.16.86.28 1.51.13.39-.09.73.07.85.39.13.32-.03.7-.42.83-1.16.4-2.05.97-2.34 1.42-.07.1-.08.18-.07.23.18.55 2.32 1.96 3.94 2.34.39.09.61.5.49.84-.17.51-1.43.96-3.5 1.28-.07.08-.15.34-.21.55-.11.39-.23.79-.5 1.04-.27.25-.61.27-.95.27-.43 0-.92-.07-1.41-.07-.31 0-.61.03-.94.13-.51.16-1.05.55-1.7 1.04-.69.51-1.47 1.09-2.61 1.09s-1.92-.58-2.61-1.09c-.65-.49-1.19-.88-1.7-1.04-.33-.1-.63-.13-.94-.13-.49 0-.98.07-1.41.07-.34 0-.68-.02-.95-.27-.27-.25-.39-.65-.5-1.04-.06-.21-.14-.47-.21-.55-2.07-.32-3.33-.77-3.5-1.28-.12-.34.1-.75.49-.84 1.62-.38 3.76-1.79 3.94-2.34.01-.05 0-.13-.07-.23-.29-.45-1.18-1.02-2.34-1.42-.39-.13-.55-.51-.42-.83.12-.32.46-.48.85-.39.65.15 1.17.03 1.51-.13-.01-.14-.01-.28-.01-.4v-.18c-.01-1.16-.03-2.59.31-3.43C6.87 3.74 9.24 2 12.03 2z" />
  </svg>
);

export default function SocialMediaDSA() {
  return (
    <section id="social-media-dsa" data-testid="social-dsa-section" className="relative py-20 lg:py-28 border-t border-black/[0.05]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* LEFT: text */}
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2b2620]">Social Media</div>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#2b2620]">
              TikTok, Instagram &amp; Co. –<br />
              <span className="gold-text">offizieller DSA-Weg bei Sperrungen.</span>
            </h2>
            <p className="mt-6 text-lg text-[#4a3f36] leading-relaxed max-w-2xl">
              TikTok weg, Instagram dicht – und niemand erklärt Ihnen, warum. Ich kenne den offiziellen Weg und begleite Sie durch den gesamten Prozess. Über die offiziellen EU-Verfahren nach dem <strong className="text-[#2b2620]">Digital Services Act (DSA)</strong>. Diskret und strukturiert.
            </p>

            <div className="mt-10 space-y-4">
              {POINTS.map(({ icon: Icon, title, text }, i) => (
                <div
                  key={title}
                  data-testid={`dsa-point-${i + 1}`}
                  className="flex items-start gap-4 p-5 rounded-2xl bg-white border border-black/[0.06] hover:border-black/15 transition-colors"
                >
                  <div className="shrink-0 w-11 h-11 rounded-xl bg-[#f5f1ea] border border-black/[0.06] flex items-center justify-center text-[#2b2620]">
                    <Icon className="w-5 h-5" strokeWidth={2} />
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-[#2b2620]">{title}</h3>
                    <p className="mt-1 text-sm text-[#6b5f52] leading-relaxed">{text}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#kontakt"
              data-testid="dsa-cta"
              className="group mt-10 inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[#2b2620] text-white font-semibold hover:bg-[#3a3128] transition-all"
            >
              Jetzt anfragen
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </a>
          </div>

          {/* RIGHT: platforms card */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="rounded-3xl bg-white border border-black/[0.06] p-6 sm:p-8 shadow-[0_30px_60px_-30px_rgba(30,31,37,0.18)]">
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#8a7f70]">Plattformen</div>
              <h3 className="mt-3 font-heading text-xl font-medium text-[#2b2620] leading-snug">
                Begleitung auf den wichtigsten Social-Media-Kanälen.
              </h3>

              <div className="mt-6 grid grid-cols-3 gap-3">
                {[
                  { Icon: TikTokIcon, label: "TikTok" },
                  { Icon: Instagram, label: "Instagram" },
                  { Icon: Facebook, label: "Facebook" },
                  { Icon: Youtube, label: "YouTube" },
                  { Icon: ThreadsIcon, label: "Threads" },
                  { Icon: Linkedin, label: "LinkedIn" },
                ].map(({ Icon, label }, i) => (
                  <div
                    key={label}
                    data-testid={`platform-${i + 1}`}
                    className="aspect-square flex flex-col items-center justify-center gap-2 rounded-2xl bg-[#f6f7fa] border border-black/[0.04] hover:bg-[#f5f1ea] hover:border-black/[0.1] transition-all"
                  >
                    <Icon className="w-6 h-6 text-[#2b2620]" />
                    <span className="text-[10px] uppercase tracking-[0.12em] text-[#6b5f52] font-medium">{label}</span>
                  </div>
                ))}
              </div>

              <div className="mt-6 p-4 rounded-2xl bg-[#f6f7fa] border border-black/[0.04]">
                <div className="flex items-start gap-3">
                  <Scale className="w-5 h-5 text-[#2b2620] shrink-0 mt-0.5" />
                  <p className="text-xs text-[#6b5f52] leading-relaxed">
                    Verfahren nach dem <strong className="text-[#2b2620]">Digital Services Act (DSA)</strong> der EU – inklusive Beschwerden bei zertifizierten außergerichtlichen Streitschlichtungsstellen. Die finale Entscheidung trifft die jeweilige Plattform.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
